import React, { useState, useEffect } from "react";
import axios from "axios";
import BgShape2 from "../../../assets/images/bg-shape2.png";
import BgLeaf2 from "../../../assets/images/bg-leaf2.png";
import { FaAward } from "react-icons/fa";
import { Link } from "react-router-dom";
import team1 from "../../../assets/images/team-1.png";
import { Row } from "react-bootstrap";
import '../../../assets/css/Profile.css';

function Vaidyaharshsehgal() {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await axios.get(
          "https://mahadevaaya.com/trilokayurveda/trilokabackend/api/profile-items/"
        );
        if (response.data.success && response.data.data.length > 0) {
          // Find the profile with ID 11 (Vaidya Harsh Sehgal) or use the first profile
          const harshProfile =
            response.data.data.find((profile) => profile.id === 11) ||
            response.data.data[0];
          setProfileData(harshProfile);
        }
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch profile data");
        setLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  if (loading) {
    return <div className="ayur-bgcover ayur-about-sec">Loading...</div>;
  }

  if (error) {
    return <div className="ayur-bgcover ayur-about-sec">{error}</div>;
  }

  if (!profileData) {
    return (
      <div className="ayur-bgcover ayur-about-sec">
        No profile data available
      </div>
    );
  }

  // Function to get the correct image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath) return team1;

    if (imagePath.startsWith("http")) {
      return imagePath;
    }

    if (imagePath.startsWith("/media/")) {
      return `https://mahadevaaya.com/trilokayurveda/trilokabackend${imagePath}`;
    }

    return `https://mahadevaaya.com/trilokayurveda/trilokabackend/${imagePath}`;
  };

  // Parse the description to extract contact information
  const descriptionLines = profileData.description
    .split("\n")
    .filter((line) => line.trim() !== "");

  // Extract Educational Qualification module to display separately
  const educationalQualification = profileData.module.find(
    (item) => item.content === "Educational Qualification:"
  );

  // Function to render module content dynamically
  const renderModuleContent = (module, index) => {
    if (!module.content && !module.description) return null;
    
    // Skip Educational Qualification as it's rendered separately
    if (module.content === "Educational Qualification:") {
      return null;
    }
    
    // Special handling for modules with bullet points (like Unique Approach)
    if (module.description && module.description.includes("•")) {
      return (
        <div key={index} className="pt-2">
          <h5>{module.content}</h5>
          {module.description.split("\n").map((paragraph, pIndex) => {
            if (paragraph.startsWith("•")) {
              return <li key={pIndex}>{paragraph.substring(1).trim()}</li>;
            }
            return <p key={pIndex}>{paragraph}</p>;
          })}
        </div>
      );
    }
    
    // Default handling for all other modules
    return (
      <div key={index} className="pt-2">
        {module.content && <h5>{module.content}</h5>}
        {module.description && module.description.split("\n").map((paragraph, pIndex) => (
          <p key={pIndex}>{paragraph}</p>
        ))}
      </div>
    );
  };

  // Check if awards data exists in the API response
  const awardsModule = profileData.module.find(
    (item) =>
      item.content === "Felicitations/Awards" || item.content === "Awards"
  );

  // Parse awards data from API if available, otherwise use hardcoded awards
  let awards = [];

  if (awardsModule && awardsModule.description) {
    // Try to parse awards from the description
    const awardLines = awardsModule.description
      .split("\n")
      .filter((line) => line.trim() !== "");
    awards = awardLines.map((line, index) => {
      // Try to extract year from the line
      const yearMatch = line.match(/(\d{1,2}\s+[A-Za-z]+\s+\d{4}|\d{4})/);
      const year = yearMatch ? yearMatch[1] : "";

      // Extract title (everything before the year or the whole line if no year)
      const title = year
        ? line.substring(0, line.indexOf(year)).trim()
        : line.trim();

      return {
        icon: <FaAward className="text-warning" />,
        title: title,
        year: year,
      };
    });
  } else {
    // Fallback to hardcoded awards if not in API
    awards = [
      {
        icon: <FaAward className="text-warning" />,
        title: "Uttarakhand Gaurav",
        year: "16th Nov. 2008",
      },
      {
        icon: <FaAward className="text-warning" />,
        title: "Technocrat's Excellency Award",
        year: "23rd Dec. 2006",
      },
      {
        icon: <FaAward className="text-warning" />,
        title: "Uttarakhand Ratna",
        year: "1st Oct. 2006",
      },
    ];
  }

  return (
    <div className="ayur-bgcover ayur-about-sec">
      <div className="about-bg">
        <div className="ayur-bread-content">
          <h2>
            {profileData.title} {profileData.full_name}
          </h2>
          <div class="ayur-bread-list">
            <span>
              <Link to="/">Home </Link>
            </span>
            <span class="ayur-active-page">
              / {profileData.title} {profileData.full_name}
            </span>
          </div>
        </div>
      </div>

      <div className="row ">
        <div className="ayur-bgcover ayur-about-sec">
          <div className="container fluid about-us">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="ayur-team-box">
                  <div className="ayur-team-img-wrapper">
                    <div className="ayur-team-img">
                      <img
                        src={getImageUrl(profileData.image)}
                        alt="team member 1"
                      />
                    </div>
                    <div className="ayur-team-hoverimg">
                      <div className="ayur-team-hoversmall">
                        <img
                          src={getImageUrl(profileData.image)}
                          alt="team member 1"
                        />
                      </div>
                      <p>Founder and CEO</p>
                      <div className="ayur-team-sociallink">
                        <Link to="">{/* Facebook SVG */}</Link>
                        <Link to="">{/* Twitter SVG */}</Link>
                        <Link to="">{/* Github SVG */}</Link>
                        <Link to="">{/* Instagram SVG */}</Link>
                      </div>
                    </div>
                  </div>
                  <div className="ayur-team-name">
                    <h3> {profileData.full_name}</h3>
                    <p>{profileData.designation}</p>
                    <p>Founder and CEO</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12 col-sm-12">
                <div className="ayur-heading-wrap ayur-about-head">
                  <h3>Trilok Ayurveda</h3>
                  {descriptionLines.map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                  
                  {/* Educational Qualification module displayed right after description */}
                  {educationalQualification && (
                    <div className="pt-2">
                      <h5>{educationalQualification.content}</h5>
                      {educationalQualification.description.split("\n").map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <Row className="ayur-heading-wrap ayur-about-head">
                <div>
                  {/* Render all modules from the API dynamically, excluding Educational Qualification */}
                  {profileData.module.map((module, index) => {
                    // Skip Educational Qualification module as it's already rendered above
                    if (module.content === "Educational Qualification:") {
                      return null;
                    }
                    return renderModuleContent(module, index);
                  })}
                  
                 
                  
                 
                </div>
              </Row>
            </div>
          </div>
          <div className="ayur-bgshape ayur-about-bgshape">
            <img src={BgShape2} alt="img" />
            <img src={BgLeaf2} alt="img" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vaidyaharshsehgal;